const ENVIRONMENT_DESCRIPTION = `Overall Environment scores out of 100, and then broken down by Resource Use, Emissions and environment-related Innovation. The higher the score the better.`;

export default ENVIRONMENT_DESCRIPTION;
